import { configureStore } from '@reduxjs/toolkit';

// Importing individual slices to manage different parts of the state
import userSlice from './Slice/userSlice'; // Manages user authentication and profile data
import homeSlice from './Slice/homeSlice'; // Manages home page data such as recent projects, industry templates, and tutorials
import MyProjectSlice from './Slice/MyProjectSlice'; // Manages user-specific projects
import liabrarySlice from './Slice/LiabrarySlice'; // Manages library data
import tutorialSlice from './Slice/TutorialSlice'; // Manages tutorial data
import DeleteObjectSlice from './Slice/gridDeleteSlice';
import GridAssetsSlice from './Slice/gridSlice';
import GlobalStatesSlice from './Slice/globalStates';
import undoRedoSlice from './Slice/undoRedoSlice';
import windowTypeSlice from './Slice/windowTypeSlice';
import particleSlice from './Slice/particleSlice';
import animationReducer from './Slice/animationSlice';
import environmentSlice from './Slice/environmentSlice';
import cameraSlice from './Slice/cameraSlice';
import physicsSlice from './Slice/physicsSlice';
import gridHistoryMiddleware from '../utils/gridHistoryMiddleware';

// import eventSlice from './Slice/eventSlice';

/**
 * Configure and create the Redux store.
 * The `reducer` object combines all slice reducers to manage different parts of the application state.
 */
const store = configureStore({
  reducer: {
    user: userSlice, // State related to user authentication and profile
    data: homeSlice, // State related to home page content
    my_project: MyProjectSlice, // State related to user's projects
    liabrary: liabrarySlice, // State related to the library section
    tutorial: tutorialSlice, // State related to tutorials
    environment: environmentSlice,

    // Grid Page Slices
    delete_object: DeleteObjectSlice, // State related to tutorials
    assets_object: GridAssetsSlice, // State related to tutorials
    global_state: GlobalStatesSlice, // State related to tutorials
    window: windowTypeSlice, // State related to tutorials
    animation: animationReducer,
    // events: eventSlice,

    // actions

    grid_actions: undoRedoSlice,
    particles: particleSlice, // <-- Register particleSlice here
    camera: cameraSlice, // <-- Register cameraSlice here
    physics: physicsSlice, // <-- Register physicsSlice here
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable the check (use with caution)
      immutableCheck: false, // Disable immutable check to allow mutation of Three.js objects
    }).concat(gridHistoryMiddleware),
});

export default store;
